import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class ExamService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {}

  findResultById(idLevel: string, targetLanguage?: string) {
    if (targetLanguage) {
      return this.http.get(`${this.toolsSrv.getApiTargetEndpoint(targetLanguage)}exams/exam/${idLevel}`, {
        headers: new HttpHeaders({
          Platform: targetLanguage
        })
      }).toPromise();
    }
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}exams/exam/${idLevel}`).toPromise();
  }

  start(idLevel: string): Promise<any> {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}exams/start/${idLevel}`).toPromise();
  }

  end(idLevel: string): Promise<any> {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}exams/end/${idLevel}`).toPromise();
  }

  generate(idLevel: string, type: string): Promise<any> {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}exams/generate/${idLevel}/${type}`).toPromise();
  }

  submit(idLevel: string, params: any): Promise<any> {
    return this.http.post(`${this.toolsSrv.getApiTargetEndpoint()}exams/submit/${idLevel}`, params).toPromise();
  }

  result(idLevel: string): Promise<any> {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}exams/result/${idLevel}`).toPromise();
  }
}
